import { callApi } from '@local_modules/generic/fetch'

/**
 *
 * @param {String} accountingOrganisationId
 * @returns
 */
export default async function loadLedgerAccounts (accountingOrganisationId) {
  const apiUrl = '/api/xero-accounting/entity-data/:accountingOrganisationId/chart-of-accounts'
  const data = await callApi(apiUrl, {
    accountingOrganisationId
  })
  console.log('loadLedgerAccounts', data)

  return data
}
